import { render, staticRenderFns } from "./ChoiceCards.vue?vue&type=template&id=f479f568&scoped=true"
import script from "./ChoiceCards.vue?vue&type=script&lang=js"
export * from "./ChoiceCards.vue?vue&type=script&lang=js"
import style0 from "./ChoiceCards.vue?vue&type=style&index=0&id=f479f568&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f479f568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f479f568')) {
      api.createRecord('f479f568', component.options)
    } else {
      api.reload('f479f568', component.options)
    }
    module.hot.accept("./ChoiceCards.vue?vue&type=template&id=f479f568&scoped=true", function () {
      api.rerender('f479f568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalog/ChoiceCards.vue"
export default component.exports